import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPage } from "../../api/pages";
import { Container } from "reactstrap";
import "./styles.css";
import SmallLoader from "../../helpers/Common/SmallLoader";
import NotFound from "../../helpers/Common/NotFound";
import MetaTags from "../../helpers/Common/MetaTags";
import { getMetaConfig } from "../../helpers/Common/metaConfig";
import { generateCmsPageSchema } from "../../helpers/Common/cmsPageSchema";

const CmsPage = () => {
  const { page } = useParams();
  const [details, setDetails] = useState({ content: "", title: "" });
  const [loading, setLoading] = useState(true);

  // Generate CMS page schema data with priority for meta_keyword and meta_description
  const cmsPageSchema = generateCmsPageSchema(details);
  
  // Generate CMS page meta tags with priority for meta_keyword and meta_description
  const cmsPageMeta = getMetaConfig('cmsPage', {
    title: details?.title || 'Page',
    description: details?.meta_description || 'Informative content and resources from JobSeekers Page. Stay updated with the latest information about our platform and services.',
    keywords: details?.meta_keyword || 'jobseekers page information, platform resources, helpful content, career resources',
    ogTitle: details?.title || 'JobSeekers Page - Informative Content and Resources',
    ogDescription: details?.meta_description || 'Access helpful content and resources about our job search and hiring platform.',
    canonicalUrl: `${window.location.origin}/page/${details?.url_slug || page}`,
    webPage: cmsPageSchema
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setLoading(true);

    if (page) {
      getPage(page)
        .then((json) => {
          setDetails({
            title: json.data?.[0]?.title,
            content: json.data?.[0]?.content,
            meta_description: json.data?.[0]?.meta_description,
            meta_keyword: json.data?.[0]?.meta_keyword,
            url_slug: json.data?.[0]?.url_slug,
            category: json.data?.[0]?.category,
            created_at: json.data?.[0]?.created_at,
            updated_at: json.data?.[0]?.updated_at
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
    }
  }, [page]);

  let content =
    details?.content && details?.title ? (
      <div className="content-sec">
        <div className="container">
          <p dangerouslySetInnerHTML={{ __html: details.content }} />
        </div>
      </div>
    ) : null;

  return (
    <>
      <MetaTags {...cmsPageMeta} />
      <Container>
        <div className="cmspage-sec">
          {loading ? (
            <SmallLoader />
          ) : details?.content && details?.title ? (
            content
          ) : (
            <NotFound />
          )}
          {/* {!details?.content && !details?.title && !loading && <h3>Not found</h3>} */}
        </div>
      </Container>
    </>
  );
};

export default CmsPage;
